import { useState } from 'react';

const files = import.meta.glob<string>('./assets/forest/*.webp', {
  eager: true,
  query: '?url',
  import: 'default',
});

/** A failed image never removes the surrounding research text or source links. */
export function ForestResearchImage({
  file,
  label,
}: {
  readonly file: string;
  readonly label: string;
}) {
  const [failed, setFailed] = useState<string | null>(null);
  const src = files['./assets/forest/' + file];
  return (
    <figure className="scc-cap-image scc-forest-image" data-forest-media={file}>
      {!src || failed === src ? (
        <div className="scc-image-fallback" role="status">
          示意图未能加载；{label}的文字说明和资料仍可阅读。
        </div>
      ) : (
        <img
          src={src}
          alt={label + '，示意图，非真实事件画面'}
          decoding="async"
          onError={() => setFailed(src)}
        />
      )}
    </figure>
  );
}
